import { render, staticRenderFns } from "./MercadosForm.vue?vue&type=template&id=6880b3f0&scoped=true"
import script from "./MercadosForm.vue?vue&type=script&lang=js"
export * from "./MercadosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6880b3f0",
  null
  
)

export default component.exports